<template>
    <div>
        <avue-crud :data="data" :option="option" :search.sync="search" @selection-change="selectionChange" @size-change="sizeChange"
                   :page.sync="page" @current-change="currentChange" @search-change="searchChange"
                   @search-reset="resetChange">
            <template slot="index" slot-scope="scope">
                {{page.total - ((page.currentPage - 1) * page.pageSize + scope.row.$index)}}
            </template>
            <template slot-scope="scope" slot="menuLeft">
                <el-button class="custom" @click="applicantBtn" v-if="user_type.user_type!==1">上传申请人身份证明</el-button>
                <el-button class="custom" @click="registerBtn">发起立案</el-button>
                <el-button class="custom" @click="batchImportBtn">批量导入案件</el-button>
                <el-button class="custom" @click="bindingListBtn" v-if="userData.platform_sn != 2">绑定证据清单</el-button>
                <el-button class="custom" @click="bindingSupplementBtn" v-if="userData.platform_sn != 2">绑定补充证据清单</el-button>
                <el-button class="custom" @click="mediatorBtn">批量提交给代理人</el-button>
            </template>
            <template slot="menuBtn" slot-scope="scope">
                <el-dropdown-item class="pull-down" @click.native="mediationProgressBtn(scope.row)">查看进度</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="mediateListBtn(scope.row)" v-if="userData.platform_sn != 2">证据材料</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="mediateSupplementBtn(scope.row)" v-if="userData.platform_sn != 2">补充证据</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="mediateDetail(scope.row)">案件详情</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="cancelBtn(scope.row)" v-if="scope.row.status==0">删除案件</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="amendBtn(scope.row)">修改立案信息</el-dropdown-item>
            </template>
            <template slot="case_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.case_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.case_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="zhcai_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.zhcai_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.zhcai_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="user_name" slot-scope="scope" >
                <el-tooltip :content="scope.row.user_name" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.user_name }}</p>
                </el-tooltip>
            </template>
            <template slot="doc_title" slot-scope="scope" >
                <el-tooltip :content="scope.row.doc_title" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.doc_title }}</p>
                </el-tooltip>
            </template>
            <template slot="contract_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.contract_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.contract_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="signers_txt" slot-scope="scope" >
                <el-tooltip :content="scope.row.signers_txt" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.signers_txt }}</p>
                </el-tooltip>
            </template>
            <template slot="tijiao_time" slot-scope="scope" >
                <el-tooltip :content="scope.row.tijiao_time" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.tijiao_time }}</p>
                </el-tooltip>
            </template>
            <template slot="lian_time" slot-scope="scope" >
                <el-tooltip :content="scope.row.lian_time" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.lian_time }}</p>
                </el-tooltip>
            </template>
            <template slot="jie_an_time" slot-scope="scope" >
                <el-tooltip :content="scope.row.jie_an_time" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.jie_an_time }}</p>
                </el-tooltip>
            </template>
        </avue-crud>
        <!--        关联证据清单-->
        <el-dialog
                title="关联证据清单"
                :visible.sync="relation"
                :close-on-click-modal ="false"
                width="60%">
            <div class="relation">
                <avue-crud :data="inventoryData" :option="option2" >
                    <template slot-scope="scope" slot="menu">
                        <el-button class="custom" @click="bindListBtn(scope.row)">绑定</el-button>
                    </template>
                </avue-crud>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="relation = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!--    关联补充证据清单    -->
        <el-dialog
                title="关联补充证据清单"
                :visible.sync="correlation"
                :close-on-click-modal ="false"
                width="60%">
            <div class="relation">
                <avue-crud :data="listData" :option="option1" >
                    <template slot-scope="scope" slot="menu">
                        <el-button class="custom" @click="bindBtn(scope.row)">绑定</el-button>
                    </template>
                </avue-crud>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="correlation = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!--        查看进度-->
        <el-dialog
                title="查看进度"
                :visible.sync="caseProgress"
                :close-on-click-modal ="false"
                width="50%">
            <div class="schedule">
                <el-timeline>
                    <el-timeline-item
                            v-for="(activity, index) in activities"
                            :key="index"
                            :icon="activity.icon"
                            :type="activity.type"
                            :color="activity.color"
                            :size="activity.size"
                            :timestamp="activity.timestamp">
                        {{activity.content}}
                    </el-timeline-item>
                </el-timeline>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="caseProgress = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!--        删除案件-->
        <el-dialog
                title="删除案件"
                :visible.sync="revokeCase"
                :close-on-click-modal ="false"
                width="30%">
            <span>请确认是否要删除该案件</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="revokeCase = false">取 消</el-button>
                <el-button type="primary" @click="revokeCaseBtn" >确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        batchBindingProof, cancelMediateCase,
        mediateList,
        mediationProgress,
        submitMediateCase,
        supplementaryEvidence
    } from '../../../api/mediateCase';
    import { associatedList, associationList } from '../../../api/contract';

    export default {
        inject: ['reload'], // 引入方法
        name: 'myMediation',
        data() {
            return {
                user_type: '',
                caseProgress:false,
                revokeCase:false, //删除案件
                cancelId:'',
                activities:[],
                userData:'',
                page: {
                    currentPage: 1,
                    total: 20,  //总数
                    pageSize: 10
                },
                relation:false,
                correlation:false,
                search: {
                    doc_title:'',
                    status:'',
                    lawyer_name:'',
                    signers:''
                },
                data: [],
                inventoryData:[],
                listData:[],
                doc_title:'',  //合同名称
                signers:'', //被申请人
                lawyer_name:'', //代理人
                status:'',  //案件状态
                option: {
                    menuType: 'menu',
                    menuBtnTitle:'操作',
                    stripe: true,
                    selection: true, //批量选择
                    addBtn: false,  //新增按钮
                    align: 'center',  //文本居中
                    menuAlign: 'center', //操作栏居中
                    columnBtn: false,  //列动态显隐按钮
                    refreshBtn: false,  //刷新按钮
                    editBtn: false,  //编辑按钮
                    delBtn: false,  //删除按钮
                    menuWidth: 150,  //操作栏宽度设置
                    column: [
                        {
                            label: '序号',
                            prop: 'index'
                        },
                        {
                            label: '案件编号',
                            prop: 'case_sn'
                        }, {
                            label: '案件批号',
                            prop: 'pi_sn'
                        }, {
                            label: '仲裁案号',
                            prop: 'zhcai_sn'
                        }, {
                            label: '申请人',
                            prop: 'user_name'
                        }, {
                            label: '合同名称',
                            prop: 'doc_title',
                            search: true
                        }, {
                            label: '合同编号',
                            prop: 'contract_sn'
                        }, {
                            label: '合同类型',
                            prop: 'product_name'
                        }, {
                            label: '被申请人',
                            prop: 'signers_txt',
                            search: true
                        }, {
                            label: '代理人',
                            prop: 'lawyer_name',
                            search: true
                        }, {
                            label: '案件状态',
                            prop: 'status',
                            search: true,
                            type: 'select',
                            dicData: [
                                {
                                    label: '全部',
                                    value: -1
                                },
                                {
                                    label: '待提交',
                                    value: 0
                                },
                                {
                                    label: '代理人处理中',
                                    value: 3
                                },
                                {
                                    label: '仲裁委审核中',
                                    value: 4
                                },
                                {
                                    label: '仲裁委审核驳回',
                                    value: 5
                                },
                                {
                                    label: '待缴费',
                                    value: 6
                                },
                                {
                                    label: '仲裁委调解中',
                                    value: 7
                                },
                                {
                                    label: '已结案',
                                    value: 8
                                },
                                {
                                    label: '已撤案',
                                    value: 9
                                }

                            ]
                        }, {
                            label: '提交案件时间',
                            prop: 'tijiao_time'
                        }, {
                            label: '立案时间',
                            prop: 'lian_time'
                        }, {
                            label: '结案时间',
                            prop: 'jie_an_time'
                        }
                    ]
                },
                option1:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:300,  //操作栏宽度设置
                    column:[
                        {
                            label:'补充证据清单id',
                            prop:'id'
                        },
                        {
                            label:'补充证据清单名称',
                            prop:'name'
                        }
                    ]
                },
                option2:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:300,  //操作栏宽度设置
                    column:[
                        {
                            label:'证据清单id',
                            prop:'id'
                        },
                        {
                            label:'证据清单名称',
                            prop:'name'
                        }
                    ]
                },
            };
        },
        methods: {
            //切换每一页数据
            sizeChange(val){
                this.page.pageSize=val
                var objNum = {
                    req_type: 0,
                    limit: val,
                    page: 1
                };
                mediateList(objNum).then(res => {
                    if (res.code==200){
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                    }
                });
            },
            //批量操作
            selectionChange(list) {
                this.ids = [];
                list.forEach(res => {
                    this.ids.push(res.id);
                });
            },
            //上传申请人身份证明
            applicantBtn() {
                this.$router.push({ path: '/applicantPage' });
            },
            //分页
            currentChange(num) {
                //分页
                if (this.doc_title==''&&this.status==''&&this.lawyer_name==''&&this.signers==''){
                    var objNum = {
                        req_type: 0,
                        limit: this.page.pageSize,
                        page: num
                    };
                    mediateList(objNum).then(res => {
                        if (res.code==200){
                            sessionStorage.setItem('myMediation',num)
                            this.data=res.data.list
                            this.page.total=res.data.count
                        }
                    });
                }else {
                    var objSerch={
                        req_type: 0,
                        doc_title:this.doc_title,  //合同名称
                        status:this.status,   //案件状态
                        lawyer_name:this.lawyer_name,   //代理人
                        signers:this.signers_txt,      //被申请人
                        limit: this.page.pageSize,
                        page: num
                    }
                    mediateList(objSerch).then(res=>{
                        if (res.code==200){
                            sessionStorage.setItem('myMediationSearch',num)
                            this.data=res.data.list
                            this.page.total=res.data.count
                        }
                    })
                }
            },
            //搜索
            searchChange(params, done) {
                var objSerch={
                    req_type: 0,
                    doc_title:params.doc_title,  //合同名称
                    status:params.status,   //案件状态
                    lawyer_name:params.lawyer_name,   //代理人
                    signers:params.signers_txt,      //被申请人
                    limit: this.page.pageSize,
                    page: 1
                }
                mediateList(objSerch).then(res=>{
                    this.doc_title=params.doc_title
                    this.status=params.status
                    this.lawyer_name=params.lawyer_name
                    this.signers=params.signers_txt
                    if (res.code==200){
                        sessionStorage.setItem('myMediationSearch',1)
                        sessionStorage.setItem('myMediationParams', JSON.stringify(params) )
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                    }
                })
                done()
            },
            //重置搜索
            resetChange() {
                var obj = {
                    req_type: 0,
                    limit: this.page.pageSize,
                    page: 1
                };
                this.doc_title=''
                this.status=''
                this.lawyer_name=''
                this.signers=''
                mediateList(obj).then(res => {
                    if (res.code==200){
                        sessionStorage.removeItem('myMediation')
                        sessionStorage.removeItem('myMediationSearch')
                        sessionStorage.removeItem('myMediationParams')
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                        this.$message.success('重置成功')
                    }
                });
            },
            //发起立案
            registerBtn(){
                this.$router.push({path:'/mediationFiling'})
            },
            //批量导入
            batchImportBtn(){
                this.$router.push({path:'/batchImportCase'})
            },
            //批量绑定证据清单
            bindingListBtn(){
                if (this.ids==undefined||this.ids==''){
                    this.$message.error('请选择要绑定的案件');
                    return
                }else {
                    associatedList().then(res=>{
                        this.relation=true
                        this.inventoryData=res.data.list
                    })
                }
            },
            //绑定证据清单
            bindListBtn(row){
                batchBindingProof(this.ids,row.id).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg);
                        this.reload()
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            },
            //批量绑定补充证据清单
            bindingSupplementBtn(){
                if (this.ids==undefined||this.ids==''){
                    this.$message.error('请选择要绑定的案件');
                    return
                }else {
                    associationList().then(res=>{
                        if (res.code==200){
                            this.correlation=true
                            this.listData=res.data.list
                        }
                    })
                }
            },
            //绑定补充证据清单
            bindBtn(row){
                supplementaryEvidence(this.ids,row.id).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg);
                        this.reload()
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            },
            //调解证据清单
            mediateListBtn(row){
                this.$router.push({path:'/mediateList',query:{id:row.id}})
            },
            //调解补充证据
            mediateSupplementBtn(row){
                this.$router.push({path:'/mediateSupplement',query:{id:row.id}})
            },
            //案件进度
            mediationProgressBtn(row){
                this.caseProgress=true
                mediationProgress(row.id).then(res=>{
                    if (res.code==200){
                        this.activities=res.data
                    }
                })
            },
            //调解详情
            mediateDetail(row){
                this.$router.push({path:'/mediateCaseDetail',query:{id:row.id}})
            },
            //批量提交给代理人
            mediatorBtn(){
                if (this.ids==undefined||this.ids==''){
                    this.$message.error('请选择要提交的文件');
                    return
                }
                this.$confirm('是否批量提交给代理人 ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    submitMediateCase(this.ids).then(res=>{
                        if (res.code==200){
                            this.$message.success(res.msg);
                            this.reload()
                        }else {
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {

                });

            },
            //删除案件
            cancelBtn(row){
                this.revokeCase=true
                this.cancelId=row.id
            },
            //确认删除案件
            revokeCaseBtn(){
                cancelMediateCase(this.cancelId).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg)
                        this.revokeCase=false
                        this.reload()
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            },
            //修改立案信息
            amendBtn(row){
                this.$router.push({path:'/editMediationPage',query:{id:row.id}})
            }

        },
        created() {
            this.userData = JSON.parse(localStorage.getItem('userData'));
            if (sessionStorage.getItem('myMediationSearch')){
                let myMediationParams=JSON.parse(sessionStorage.getItem("myMediationParams"));
                this.search=myMediationParams
                var objSerchParams={
                    req_type: 0,
                    doc_title:myMediationParams.doc_title,  //合同名称
                    status:myMediationParams.status,   //案件状态
                    lawyer_name:myMediationParams.lawyer_name,   //代理人
                    signers:myMediationParams.signers_txt,      //被申请人
                    limit: this.page.pageSize,
                    page: sessionStorage.getItem('myMediationSearch')
                }
                mediateList(objSerchParams).then(res=>{
                    if (res.code==200){
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=sessionStorage.getItem('myMediationSearch')
                    }
                })
            }else {
                if (sessionStorage.getItem('myMediation')===null){
                    var obj = {
                        req_type: 0,
                        limit: this.page.pageSize,
                        page: 1
                    };
                    mediateList(obj).then(res => {
                        if (res.code==200){
                            this.data=res.data.list
                            this.page.total=res.data.count
                            this.page.currentPage=1
                        }
                    });
                }else {
                    var obj = {
                        req_type: 0,
                        limit: this.page.pageSize,
                        page: sessionStorage.getItem('myMediation')
                    };
                    mediateList(obj).then(res => {
                        if (res.code==200){
                            this.data=res.data.list
                            this.page.total=res.data.count
                            this.page.currentPage=sessionStorage.getItem('myMediation')
                        }
                    });
                }
            }


            this.user_type = JSON.parse(sessionStorage.getItem('shenfen'));

        }
    };
</script>

<style scoped>
    .custom {
        background-color: #3e62f6;
        color: #fff;
    }
    .schedule{
        height: 400px;
        overflow: auto;
    }
    /deep/.el-timeline{
        width: 50%;
        margin: auto;
    }
    /deep/.el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }
    /deep/.el-icon-arrow-down {
        font-size: 15px;
    }
    .pull-down{
        padding: 5px 30px !important;
    }
    ::v-deep .avue-form__row{
        width: 20%;
    }
    ::v-deep .avue-form__menu{
        width: 200px;
    }
    ::v-deep .avue-form__group{
        align-items: flex-end;
    }
    .textStyle{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: default;
        margin:0;
    }
</style>
